import { z } from 'zod';

import { toolSchema } from './tool.schema';

export const agentDefinitionSchema = z.object({
  id: z.string().uuid(),
  organization_id: z.string().uuid().optional().nullable(),
  name: z
    .string()
    .min(1, 'Name is required')
    .max(100)
    .regex(/^[a-z][a-z0-9_]*$/, 'Name must be snake_case (e.g., intake_agent)'),
  role: z.string().min(1, 'Role is required').max(200),
  prompt_template: z
    .string()
    .min(10, 'Prompt template must be at least 10 characters')
    .max(50000, 'Prompt template must not exceed 50,000 characters'),
  welcome_message: z.string().optional().nullable(),
  tools: z.array(toolSchema).default([]),
  custom_tool_ids: z.array(z.string().uuid()).default([]),
  voice_name: z.string().max(100).optional().nullable(),
  advanced: z.record(z.string(), z.unknown()).default({}),
  handoff_conditions: z.string().optional().nullable(),
  is_active: z.boolean().default(true),
  created_at: z.date().or(z.string().datetime()),
  updated_at: z.date().or(z.string().datetime()),
});

export type AgentDefinition = z.infer<typeof agentDefinitionSchema>;

export const createAgentDefinitionSchema = agentDefinitionSchema.omit({
  id: true,
  organization_id: true,
  created_at: true,
  updated_at: true,
});

export type CreateAgentDefinitionDto = z.infer<typeof createAgentDefinitionSchema>;

export const updateAgentDefinitionSchema = createAgentDefinitionSchema.partial();

export type UpdateAgentDefinitionDto = z.infer<typeof updateAgentDefinitionSchema>;

export const configurationAgentSchema = z.object({
  id: z.string().uuid(),
  configuration_id: z.string().uuid(),
  agent_id: z.string().uuid(),
  sort_order: z.number().int().min(0),
  is_entry_agent: z.boolean().default(false),
  agent: agentDefinitionSchema,
});

export type ConfigurationAgent = z.infer<typeof configurationAgentSchema>;

export const upsertConfigurationAgentsSchema = z.object({
  agents: z.array(
    z.object({
      agent_id: z.string().uuid(),
      sort_order: z.number().int().min(0),
      is_entry_agent: z.boolean(),
    }),
  ),
});

export type UpsertConfigurationAgentsDto = z.infer<typeof upsertConfigurationAgentsSchema>;
